import React from 'react'
import TelInput from '../base/TelInput'
import {INPUT_TYPES} from '../../../utilities/form-helpers/FormBuilder'

const SecondaryTelInput = props => <TelInput variant={INPUT_TYPES.secondary} {...props} />

export default SecondaryTelInput
